const commonObj = {
  props: [
    'parseListIndexOf'
  ],
  data() {
    return {
      clickFunc: () => { },
      blurFunc: () => { },
      keyUpFunc: () => { },
      changeFunc: () => { },
      checkBoxClickFunc: new Map(),
      readonlyBackgroundFlag: false,
    };
  },
  computed: {
    getRequired() {
      if (this.data === undefined || this.data.validate === undefined || this.data.validate.length === 0) {
        return false;
      }
      if (this.data.validate.required !== undefined && this.data.validate.required[0] === true) {
        return true;
      }
      return false;
    },

    getReadonlyBackground() {
      if (this.readonlyBackgroundFlag) {
        return false;
      } else {
        return this.data.readonly;
      }
    },

    getMaxLength() {
      if (this.data.validate !== undefined && this.data.validate !== null && this.data.readonly !== true && this.data.disabled !== true) {
        let _maxLength = 0;
        if (this.data.validate.maxLength !== undefined) {
          try {
            _maxLength = this.data.validate.maxLength[0];
          } catch (e) { // 适配Excel中没有Tips的情况
            _maxLength = this.data.validate.maxLength;
          }
          return _maxLength;
        } else if (this.data.validate.rangeLength !== undefined) {
          try {
            _maxLength = this.data.validate.rangeLength[0][1];
          } catch (e) { // 适配Excel中没有Tips的情况
            _maxLength = this.data.validate.maxLength[1];
          }
          return _maxLength;
        };
        return 99;
      }
      return 99;
    }
  },
  methods: {
    $parseInitData() {
      switch (this.opCode) {
        case '0':
          break;
        case '1':
          if (this.data.modifyShow === false) {
            this.data.hidden = true;
          } else if (this.data.modifyShow === true) {
            this.data.hidden = false;
          }
          // 可修改字段
          if (this.data.couldMod === false) {
            this.data.readonly = true;
          }
          break;
        case '2':
          // 可批量修改字段
          if (this.data.couldBatchMod === false) {
            this.data.hidden = true;
          }
          break;
        case '3':
          if (this.data.batch_hidden === true) {
            this.data.hidden = true;
          } else if (this.data.batch_hidden === false) {
            this.data.hidden = false;
          }
          break;
        default:
      }
      if (this.data.uiIndex === undefined) this.data.hidden = true;
    },

    setParam(_paramName, _paramVal) {
      switch (_paramName) {
        case 'name':
          this.params.name = _paramVal;
          break;
        case 'value':
          this.params.paramVal = _paramVal;
          break;
        case 'readonly':
          this.data.readonly = _paramVal;
        default:
          this.data[_paramName] = _paramVal;
          // 骚套路,强制让组件刷新...
          const _temp = this.params.paramVal;
          this.params.paramVal = 0;
          this.params.paramVal = _temp;
      }
    },

    getParam(_paramName) {
      switch (_paramName) {
        case 'name':
          return this.getData().name;
          break;
        case 'value':
          return this.getData().paramVal;
          break;
        default:
          return this.data[_paramName];
      }
    },

    getData() {
      // this.$formatData();
      return this.params;
    },
    setData(_data) {
      this.params.paramVal = _data;
    },

    getRefObj() {
      return this.$refs[this.data.name];
    },

    setReadOnlyBackgroundNoGray() {
      this.readonlyBackgroundFlag = true;
    },

    removeReadOnlyBackgroundNoGray() {
      this.readonlyBackgroundFlag = false;
    },

    $formatData() {
      const _valueType = this.data.valueType;
      if (_valueType === undefined) return;
      const _type = _valueType.toUpperCase();
      switch (_type) {
        case 'STRING':
          try {
            this.params.paramVal = (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) ? '' : this.params.paramVal.toString();
          } catch (e) {
            console.log(this.data.name + '转String类型错误, 请检查当前值');
          }
          break;
        case 'STRING[]':
          try {
            if (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) {
              this.params.paramVal = [];
            } else if (this.params.paramVal instanceof Array) {
            } else {
              console.log(this.data.name + '转String[]类型错误, 请检查当前值');
            }
          } catch (e) {
            console.log(this.data.name + '转String类型错误, 请检查当前值');
          }
          break;
        case 'BYTE':
          try {
            this.params.paramVal = (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) ? 0 : parseInt(this.params.paramVal);
          } catch (e) {
            console.log(this.data.name + '转Byte类型错误, 请检查当前值');
          }
          break;
        case 'SHORT':
          try {
            this.params.paramVal = (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) ? 0 : parseInt(this.params.paramVal);
          } catch (e) {
            console.log(this.data.name + '转Short类型错误, 请检查当前值');
          }
          break;
        case 'INTEGER':
          try {
            this.params.paramVal = (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) ? 0 : parseInt(this.params.paramVal);
          } catch (e) {
            console.log(this.data.name + '转Int类型错误, 请检查当前值');
          }
          break;
        case 'LONG':
          try {
            this.params.paramVal = (this.params.paramVal === null && this.params.paramVal === '' && this.params.paramVal === undefined) ? 0 : parseInt(this.params.paramVal);
          } catch (e) {
            console.log(this.data.name + '转Long类型错误, 请检查当前值');
          }
          break;
        default:
      }
    }
  },
};
export default commonObj;
